import { useEffect, useState } from 'react';
import { UpOutlined } from '@ant-design/icons';
import { ScrollToTopButton } from './styles';

export default function ScrollToTop() {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    return (
        <ScrollToTopButton
            onClick={scrollToTop}
            isVisible={isVisible}
        >
            <UpOutlined />
        </ScrollToTopButton>
    );
}